import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { GetOrders } from '../../../helpers';
import { FiChevronLeft } from "react-icons/fi";
import { Link } from 'react-router-dom';
import { Table, Tab, Tabs } from 'react-bootstrap';
import MUIDataTable from "mui-datatables";


const ViewPayments = () => {
    const [isLoading, setLoading] = useState(true);
    const [order, setOrder] = useState(null);
    const [expandedRows, setExpandedRows] = useState([]);
    const { orderid } = useParams();
    const [key, setKey] = useState('payment_details');
    const getOrder = async (orderid) => {
        const resp = await GetOrders.getSingleOrderPayments(orderid);
        if (resp && resp.status) {
            setOrder(resp.order)
            setLoading(false);
        }
    }

    useEffect(() => {
        getOrder(orderid)
    }, [orderid])


    const getDateTime = (dataTime) => {
        const dateObj = new Date(dataTime);
        const date = dateObj.toLocaleDateString('en-GB', {
            timeZone: 'Europe/London'
        });

        const time = dateObj.toLocaleTimeString('en-GB', {
            timeZone: 'Europe/London',
            hour: 'numeric',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
        });

        return `${date} - ${time}`;
    }


    const options = {
        filter: false,
        search: false,
        download: false,
        print: false,
        selectableRows: 'none',
        expandableRows: true,
        rowsExpanded: expandedRows,
        onRowExpansionChange: (curExpanded, allExpanded) => {
            setExpandedRows(allExpanded.map(row => row.dataIndex));
        },
        renderExpandableRow: (rowData, rowMeta) => {
            const refund = order.refunds[rowMeta.dataIndex];
            console.log(refund);
            return (
                <tr>
                    <td colSpan={12}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: "5px" }}>
                            <h5 style={{ fontSize: 16, marginTop: 10, marginBottom: 10 }}>Refund Orders</h5>
                        </div>
                        <table className="table table-bordered ft-12">
                            <thead className="thead-light">
                                <tr style={{ backgroundColor: '#e5e5e5e5' }}>
                                    <th style={{ fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>ID</th>
                                    <th style={{ textAlign: 'center', fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>Thumbnail</th>
                                    <th style={{ fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>SKU</th>
                                    <th style={{ fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>Refund QTY</th>
                                    <th style={{ fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>Oredered QTY</th>
                                    <th style={{ fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>Refund Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {refund.refund_items.map((refundItem, index) => {

                                    let thumbnailImage = refundItem.order_item.product ? refundItem.order_item.product.product_thumbnail?.path : refundItem.order_item.variation_product.variation_main_image?.path;
 
                                    return <tr key={index}>
                                        <td>{refundItem.id}</td>
                                        <td style={{ textAlign: 'center' }}><img src={thumbnailImage} alt='img' width={50} /></td>
                                        <td style={{ maxWidth: 200 }}>{refundItem.order_item.pro_sku || refundItem.order_item.var_sku}</td>
                                        <td style={{ maxWidth: 200 }}>{refundItem.refunded_quantity}</td>
                                        <td style={{ maxWidth: 200 }}>{refundItem.order_item.quantity}</td>
                                        <td style={{ maxWidth: 200 }}>£ {refundItem.refunded_amount}</td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </td>
                </tr>
            );
        }
    };

    const columns = [
        {
            name: 'SL'
        },
        {
            name: 'Order Number',
            sortable: true,
        },
        {
            name: 'Refund ID',
            sortable: true,
        },
        {
            name: 'Amount',
            sortable: true,
        },
        {
            name: 'Reason',
            sortable: true,
        },
        {
            name: 'Status',
            sortable: true,
        }
    ];


    return (
        <div className='singleOrderWrapper'>
            {
                isLoading ? <div className='loader'>
                    <img src='/images/loader.gif' alt='loader' />
                </div> : <div className='container-fluid'>
                    <div className='orderHeader' >
                        <Link to="/app/orders/view" className='goBack no-print'><FiChevronLeft /></Link>
                        <div className='orderHeaderLeft'>
                            <div className='orderHeaderLeft'>
                                <div className='orderStatus'>
                                    <span className='orderNumber'>#{order.order_number}</span>
                                    <h5>Payment Details</h5>
                                </div>

                                <div className='orderDate'>{getDateTime(order.createdAt)} from Triplast</div>
                            </div>
                        </div>
                        <div className='orderHeaderRight'>


                        </div>
                    </div>
                    <div className='orderDetails' style={{ padding: '20px 20px 50px 20px', }}>
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="mb-3"
                        >
                            <Tab eventKey="payment_details" title="Payment Details">
                                {order.payment ? (
                                    <>

                                        <Table className='ft-14'>
                                            <tbody>
                                                <tr><th>Transaction ID</th><td>{order.payment.transaction_id || order.payment.intent_id}</td></tr>
                                                <tr><th>Order Number</th><td>{order.payment.order_number}</td></tr>
                                                <tr><th>Amount</th><td>£ {order.payment.amount}</td></tr>
                                                <tr><th>Currency</th><td>{order.payment.currency}</td></tr>
                                                <tr><th>Payment Method</th><td>{order.payment.payment_method || order.payment.method}</td></tr>
                                                <tr><th>Payment Status</th><td>{order.payment.payment_status || order.payment.status}</td></tr>
                                                <tr><th>Payment Date</th><td>{order.payment.payment_date}</td></tr>
                                            </tbody>
                                        </Table>
                                        <div className='completeDetails'>
                                            <h6 style={{ marginBottom: 10, marginTop: 20 }}>Complete Payment Details</h6>
                                            <code>
                                                {order.payment.complete_details}
                                            </code>
                                        </div>
                                    </>
                                ) : (
                                    <p>No details available.</p>
                                )}
                            </Tab>
                            <Tab eventKey="payment_refund" title="Refund Details">
                                {
                                    order.refunds && order.refunds.length > 0 &&
                                    <MUIDataTable className="hideHeader"

                                        data={order.refunds.map((item, i) => {
                                            return [
                                                ++i,
                                                item.order_number,
                                                item.refund_id,
                                                `£ ${item.amount}`,
                                                item.reason,
                                                <div className={`badge ${item.status === "succeeded"
                                                    ? "bg-success"
                                                    : item.status === "failed"
                                                        ? "bg-danger"
                                                        : item.status === "pending"
                                                            ? "bg-warning"
                                                            : "bg-info"
                                                    }`}>
                                                    {item.status}
                                                </div>


                                            ]
                                        })}
                                        columns={columns}
                                        options={options}
                                    />
                                }
                            </Tab>

                        </Tabs>
                    </div>
                </div>
            }
        </div>
    )
}

export default ViewPayments;